import { useContext } from "react";
import ConfigContext from "@/features/config/context/ConfigContext.tsx";

const useConfig = () => {
  return useContext(ConfigContext);
}

export default useConfig;
